import { DateInput, FormField, getErrors } from '@maia/ui';
import { formatDateInputValue, formatDateToCalendarDate } from '@maia/utils';
import { ComponentProps } from 'react';
import { useFieldContext } from '../dynamic-form';
import { flow } from 'es-toolkit';

type DateFieldProps = {
  includePicker?: boolean;
  minValue?: Date;
  inputOverrides?: ComponentProps<typeof DateInput>;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function DateField(props: DateFieldProps) {
  const { inputOverrides, ...rest } = props;
  const field = useFieldContext<Date | null>();
  const handleChange = flow(formatDateInputValue, field.handleChange);

  const defaultValue = field.state.value
    ? field.state.value instanceof Date
      ? field.state.value
      : new Date(field.state.value)
    : null;

  const formattedDefaultValue = formatDateToCalendarDate(defaultValue);

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <DateInput
          includePicker={rest.includePicker}
          minValue={
            rest.minValue ? formatDateToCalendarDate(rest.minValue) : undefined
          }
          defaultValue={formattedDefaultValue}
          onChange={handleChange}
          {...inputOverrides}
        />
      }
    />
  );
}
